/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".receive-card[_ngcontent-%COMP%]{min-height:calc(100vh - 265px)}.subtitle[_ngcontent-%COMP%]{color:#2c231b;font-family:\"Itau Display\";font-size:24px;font-weight:300;line-height:36px;padding:25px 0 15px}@media (min-width:768px){.receive-card[_ngcontent-%COMP%]{min-height:calc(100vh - 325px)}}@media (min-width:1600px){.receive-card[_ngcontent-%COMP%]{min-height:calc(100vh - 541px)}.subtitle[_ngcontent-%COMP%]{font-size:32px}}"];
export { styles as styles };
